module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Rogers_With_All_Our_Prayers_text_CC5#toc2"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTOCAnchor-1"
    }
  }), _vm._v("Introduction: With All Our Prayers")]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("In the name of the Father, and of the Son, and of the Holy Spirit, let us pray: We come to you in prayer, Eternal God, able to do so because you have first come to us, and daring to do so because, having created us for yourself, claimed us for your own possession, and called us to be your covenant people, you have made the gift of prayer a defining mark of our life with you. You have revealed to us your name so that we know to whom we pray. You have called us by name so that we may pray with confidence that we are known of you and that we matter to you both presently and ultimately. Just so do our prayers express our faith born of your faithfulness. Just so are they our trusting words in answer to your sovereign Word uttered from the foundation of the world, living and active to accomplish your promised salvation and to bear your righteous command, and incarnate in Jesus Christ our Lord. By his grace, and in the fellowship of the Holy Spirit, our lives are anchored in your love and hidden securely in your own triune life. Wherefore we come to you with all our prayers.")]), _vm._v(" "), _c('p', {
    staticClass: "AX"
  }, [_vm._v("Amen.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e754688e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rogers_With_All_Our_Prayers_text_CC-4.vue
// module id = 66
// module chunks = 0